<template>
  <div class="d-flex justify-content-end align-items-center refreshbutton">
    <button
    v-if="0"
      class="refresh-dashboard-data"
      :disabled="!isRecreated"
      :class="!isRecreated ? 'disable-btn' : ''"
      @click="forceRecreation"
    >
      <i class="bi bi-arrow-clockwise refresh-icon"></i>
      <span class="refresh-text">{{ $t("homePage.updateDate") }}</span>
    </button>
  </div>

  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
  >
    <div class="w-full flex flex-col gap-2 py-4 md:py-4 md:px-4">
      <div
        id="box-live-round"
      class="min-w-full"
      >
        <RoundLiveInfo :key="chartKey" />
      </div>

      <div class="box large session-box-custom-padding" v-if="0">
        <SessionDuration
          title="Live sessions"
          :key="chartKey"
          :showGridFullWidth="false"
        />
      </div>

      <div v-if="0" class="box large box-no-min-h" style="overflow: visible">
        <TopPlayer :key="chartKey" />
      </div>
    </div>
  </main>

  <LivePlayersModal v-if="livePlayerModalOpen" />
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

import RoundLiveInfo from "../components/RoundLiveInfo.vue";
import SessionDuration from "../components/SessionDuration.vue";
import LivePlayersModal from "../components/LivePlayersModal.vue";
import TopPlayer from "../components/TopPlayer/TopPlayer.vue";

const store = useStore();

const period = ref("7days");
const chartKey = ref(0);
const isRecreated = ref(true);

const dbSelected = computed(() => store.getters.selectedDatabase);

const isMenuOpen = computed(() => store.getters.isMenuOpen);
const livePlayerModalOpen = computed(() => store.getters.livePlayerModalOpen);
const isAdmin = computed(() => store.getters.isAdmin);
const multipleMultipliersGames = computed(
  () => store.getters.multipleMultipliersGames,
);

const isMultiplierMultiplierGames = computed(() => {
  return multipleMultipliersGames.value?.includes(dbSelected.value) ?? false;
});

const setPeriod = (newPeriod) => {
  if (period.value !== newPeriod) {
    period.value = newPeriod;
  }
};

const forceRecreation = () => {
  chartKey.value += 1;
  isRecreated.value = false;

  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 250);

  setTimeout(() => {
    isRecreated.value = true;
  }, 10000);
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/components/home.scss";

.box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 650px) {
    padding: 0px 5px;
  }
}

.button-group {
  margin-bottom: 20px;
}

.box-rooms {
  padding: 20px 20px 20px 20px;
  min-height: 0px;

  @media (max-width: 650px) {
    padding: 20px 10px 20px 10px;
  }

  // min-height: 390px ;
}

.button-period {
  // margin: 0px 5px;
  min-height: 25px;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  // background-color: #39993c;
  font-size: clamp(10px, 1vw, 16px);
  text-transform: uppercase;
  letter-spacing: -0.07em;
  min-width: 50px;
  font-weight: 600;
  color: rgb(255, 255, 255);
}

button.active {
  // background-color: #007bff;
  color: white;
  box-shadow: inset 0px 0px 5px -1px #ffffff;
  font-weight: bold;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-1 {
  margin-bottom: 1.5rem;
}

.multipliers-range-w-dynamic {
  @media (max-width: 850px) {
    grid-column: span 2;
    grid-row: span 1.5;
  }
}

.period-image {
  max-width: 20px;
  max-height: 20px;
  object-fit: contain;
  margin-right: 5px;

  @media (max-width: 650px) {
    max-width: 15px;
    max-height: 15px;
  }
}

.custom-padding {
  padding: 20px;

  @media (max-width: 650px) {
    padding: 20px 5px;
  }
}

.refresh-dashboard-data {
  background-color: white;
  padding: 10px;
  margin: 15px 20px 0px;
  border-radius: 8px;
  transition: 0.3s allease;
  color: rgb(0, 0, 0);
  font-weight: bold;
  border: 2px solid #000000;
  transition: 0.3s all ease;

  @media (max-width: 767px) {
    margin: 15px 0px 0px;
  }
}

.disable-btn {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>

<style lang="scss">
.fa-calendar-alt,
.fa-chart-bar,
.fa-layer-group {
  @media (max-width: 380px) {
    display: none;
  }
}

.btn-modern {
  @media (max-width: 500px) {
    font-size: 12px;
    letter-spacing: -0.09em;
  }

  @media (max-width: 380px) {
    font-size: 12px;
  }
}

.custom-dropdown .dropdown-menu {
  @media (max-width: 380px) {
    left: -75px;
  }
}

.no-data-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.refreshbutton {
  padding-top: 90px;
  width: 100%;

  .refresh-icon {
    margin-right: 5px;
  }

  @media (max-width: 650px) {
    width: auto;
    padding-top: 0px;
    position: fixed;
    bottom: 10px;
    right: 0;
    z-index: 120;

    .refresh-dashboard-data {
      background-color: rgb(39 125 210);
      border-radius: 90px 0px 0px 90px;
      min-width: 50px;
      min-height: 50px;
      padding: 0;
      margin: 0;
      border-right: 0px solid;

      .refresh-icon {
        margin-right: 0px;
      }

      &:hover {
        background-color: rgb(83, 148, 214);
      }

      i {
        position: relative;
        top: 1px;

        @media (max-width: 650px) {
          font-size: 20px;
        }
      }
    }

    .refresh-text {
      display: none;
    }
  }
}

.session-box-custom-padding {
  padding: 20px 20px 20px 20px;

  @media (max-width: 991px) {
    padding: 20px 10px 20px 10px;
  }
}
</style>
